import { Drawer } from "@intility/bifrost-react";
import type { ClientListItem } from "../api/types";
import { ClientManifestTab } from "../pages/clients/ClientDetail/ClientManifestTab";
import { useCanEditClient } from "./useCanEditClient";

// The client's manifest with all its functions (view, edit, upload, preview,
// apply), the same view as the Manifest tab on the client page, in a drawer.
export function ClientManifestDrawer({
  client,
  open,
  onClose,
}: {
  client: ClientListItem;
  open: boolean;
  onClose: () => void;
}) {
  const canEdit = useCanEditClient(client);

  return (
    // The manifest view opens its own confirm dialog; Bifrost warns that a
    // drawer and a modal open together fight over keyboard focus, and the
    // dialog's state is not reachable from here, so the drawer's trap is off.
    <Drawer
      isOpen={open}
      onRequestClose={onClose}
      header="Client manifest"
      disableFocusTrap
    >
      {/* Mounted only while open, so the manifest is fetched on demand. */}
      {open && (
        <div style={{ marginTop: 24 }}>
          <ClientManifestTab
            clientId={client.clientId}
            canEdit={canEdit}
            inDrawer
          />
        </div>
      )}
    </Drawer>
  );
}
